<script>
	import Particles from './Particles.svelte';

	import * as config from "./config";
	console.log(Particles)

	export const addToMetaMask = async function () {
		if (window.ethereum === undefined) {
			alert("No MetaMask found");
			return;
		}

		if (!window.ethereum.isMetaMask) {
			alert("Please install MetaMask and try again!");
			return;
		}

		try {
			const wasAdded = await window.ethereum.request({
				method: "wallet_watchAsset",
				params: {
					type: "ERC20",
					options: {
						address: config.tokenAddress,
						symbol: config.tokenSymbol.substr(0, 11),
						decimals: config.tokenDecimals,
						image: config.tokenImage,
					},
				},
			});

			if (wasAdded) {
				console.log("Added successful");
			} else {
				console.log("Token was not added");
			}
		} catch (e) {
			console.log(e); // eslint-disable-line no-console
		}
	};
</script>

<main>
	<div id="container">
		<div class="token-container">
			<img
				src={config.tokenImage}
				alt="Adora Token Logo"
				class="token-image"
			/>
			<h1>Adora</h1>
			<hr />
			<div class="token-details">
				<h6>
					Name: <span class="text-muted">{config.tokenName}</span>
				</h6>
				<h6>
					Symbol: <span class="text-muted">{config.tokenSymbol}</span>
				</h6>
				<h6>
					Decimals: <span class="text-muted"
						>{config.tokenDecimals}</span
					>
				</h6>
				<h6>
					Address: <span class="text-muted token-address"
						>{config.tokenAddress}</span
					>
				</h6>
			</div>
			<hr />
			{#if window.ethereum !== undefined}
				<button on:click={async () => addToMetaMask()}
					><svg
						viewBox="0 0 16 16"
						width="1em"
						height="1em"
						focusable="false"
						role="img"
						aria-label="plus circle fill"
						xmlns="http://www.w3.org/2000/svg"
						fill="currentColor"
						class="bi-plus-circle-fill b-icon bi"
						><g
							><path
								d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8.5 4.5a.5.5 0 0 0-1 0v3h-3a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3v-3z"
							/></g
						></svg
					>
					Add to MetaMask
				</button>
			{:else}
				<h4>No metamask installation found!</h4>
			{/if}
		</div>
	</div>
</main>

<style>
	#container {
		position: relative;
	}

	#tsparticles {
		position: absolute;
		top: 0;
		left: 0;

		padding: 0;
		margin: 0;
		z-index: 0; /* if you use -1 you have to set to `"window"` the interactivity.detectsOn property */
	}

	.token-details {
		height: 100px;
	}

	button {
		margin: 0 0 10px 10px;
	}

	.bi-plus-circle-fill {
		margin-top: auto;
		margin-bottom: auto;
	}
	.token-container {
		max-width: 680px;
		margin: 0 auto 0 auto;
		background: white;
		z-index: 1;
	}

	.token-image {
		padding: 1em;
		object-fit: cover;
		height: 6em;
		float: left;
	}
	main {
		padding: 0;
		max-width: 240px;
		margin: 0 auto;
		position: relative;
	}

	h1 {
		color: #ff3e00;
		text-transform: uppercase;
		margin-bottom: 20px;
		font-size: 4em;
		font-weight: 100;
	}

	.token-details {
		column-count: 2;
		padding-left: 10px;
		padding-right: 10px;
	}

	.token-details > h6 {
		margin: 0 0 0 0;
		padding: 0 0 0 0;
	}

	@media (min-width: 640px) {
		main {
			max-width: none;
		}
	}
</style>
